import React from "react";
import "./Footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* Column 1 - About */}
        <div className="footer-col">
          <h3>EduX</h3>
          <p>
  A modern cloud-based platform that simplifies academic and administrative management for schools, colleges, and universities.
</p>

        </div>

        {/* Column 2 - Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/features">Features</a></li>
            <li><a href="/">Schedule Demo</a></li>
            <li><a href="/pricing">Pricing</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Column 3 - Contact */}
        <div className="footer-col">
          <h4>Contact Us</h4>
          <p>Email: <a href="mailto:hello@SuperXTech.io">hello@SuperXTech.io</a></p>
          <p>Phone: <a href="tel:+919078979508">+91 9078979508</a></p>
          <p>Address: Plot No.86/A,3rd Floor, 
            Saheed Nagar, Bhubaneswar, 751007,Odisha</p>
        </div>

        {/* Column 4 - Social Media */}
        <div className="footer-col">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="https://www.facebook.com/SuperXTech" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.linkedin.com/company/superxtech" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
            {/* <a href="https://www.instagram.com/SuperXTech" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a> */}
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} All rights reserved | SuperXTech Solutions Pvt Ltd  </p>
      </div>
    </footer>
  );
}
